import axios from 'axios'
export const urlShortner = (data) => {
    return axios({
        url: 'https://api.rebrandly.com/v1/links',
        method: 'post',
        data: JSON.stringify(data),
        headers: {
            "Content-Type": "application/json",
            "apikey": "f3c58acd471346b7ba9674ef2e281a61"
        }
    }).then(res => {
        return res
    }).catch(err => {
        return Promise.reject(JSON.stringify(err))
    })
}



export const deleteUrl = (id) => {
    return axios({
        url: `https://api.rebrandly.com/v1/links/${id}`,
        method: 'delete',
        headers: {
            "Content-Type": "application/json",
            "apikey": "f3c58acd471346b7ba9674ef2e281a61"
        }
    }).then(res => {
        return res
    }).catch(err => {
        return Promise.reject(error.response)
    })
}

export const getUrlShortener = (id) => {
    return axios({
        url: `https://api.rebrandly.com/v1/links/${id}`,
        method: 'get',
        headers: {
            "Content-Type": "application/json",
            "apikey": "f3c58acd471346b7ba9674ef2e281a61"
        }
    }).then(res => {
        return res
    }).catch(error => {
        return Promise.reject(error.response)
    })
}

export const attachTag = (id) => {
    return axios({
        url: `https://api.rebrandly.com/v1/links/${id}/tags/LINKP1`,
        method: 'post',
        headers: {
            "Content-Type": "application/json",
            "apikey": "f3c58acd471346b7ba9674ef2e281a61"
        }
    }).then(res => {
        return res
    }).catch(err => {
        return Promise.reject(JSON.stringify(err))
    })
}
